export const firebaseConfig = {
  apiKey: "AIzaSyCo4G-BbCLPvXP-Kn-l5ro5PrqWqXYmnxE",
  authDomain: "waypoint-e9a8e.firebaseapp.com",
  databaseURL: "https://waypoint-e9a8e.firebaseio.com",
  projectId: "waypoint-e9a8e",
  storageBucket: "waypoint-e9a8e.appspot.com",
  messagingSenderId: "71966208760",
  appId: "1:71966208760:web:24130dc115d6f0f98f810d",
};
